/**
 * Mutations for wordpress/themes module
 */
import initialState from './state'
import types from './types'

const themesProps = ['colors', 'css', 'navigation', 'sidebar', 'footer']

function treeShake (state) {
  Object.keys(state).forEach(prop => {
    if (!themesProps.includes(prop)) delete state[prop]
  })
}

function mutate (state, payload) {
  themesProps.forEach(prop => { state[prop] = payload && payload[prop] ? payload[prop] : initialState[prop] })
}

const mutations = {
  [types.FETCH]: (state, payload) => {
    treeShake(state)
    mutate(state, payload)
  },
  [types.UPDATE]: (state, payload) => {
    treeShake(state)
    mutate(state, payload)
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/themes/mutations.js